import React, { useContext } from 'preact/compat';

import { EmbarkCart } from 'shopify-buy';
import { FlagContext } from './Context/flag';
import { getLineItemsCount } from '../storefront-cart';

interface Props {
  cart: EmbarkCart | null;
}

export const DrawerFooter: React.FC<Props> = ({ cart }) => {
  let isAnyLineDiscounted = false;

  if (cart?.lines?.edges) {
    cart.lines.edges.forEach((line) => {
      if (line.node.discountAllocations.length) {
        isAnyLineDiscounted = true;
      }
    });
  }

  const isDiscounted =
    cart && (isAnyLineDiscounted || cart.discountAllocations.length > 0);
  const flags = useContext(FlagContext);

  return (
    <div className="cart-drawer__footer">
      <div className="cart-drawer__footer-item">
        {flags && !flags.ENABLE_DISCOUNT_APPLICATION ? (
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          //@ts-ignore
          <discounter-summary className={'hidden'} />
        ) : null}
      </div>
      <div className="cart-drawer__footer-item">
        <div className="item-key">Shipping</div>
        <div className="item-value">Free US Shipping</div>
      </div>
      <div className="cart-drawer__footer-item cart-drawer__footer-item--em">
        <div className="item-key">
          Subtotal ({getLineItemsCount(cart)} items)
        </div>
        <div
          className={`will-load item-value ${
            isDiscounted ? 'discounted' : 'regular'
          }`}
        >
          <span className={'sr-only'}>Regular Price: </span>
          <span>
            {window.Shopify.formatMoney(
              (cart?.cost.checkoutChargeAmount?.amount || 0) * 100,
              window.Shopify.money_format
            )}
          </span>
        </div>
        {isDiscounted && (
          <div className={'item-value will-load'}>
            <span className={'sr-only'}>Current Price: </span>
            <span>
              {window.Shopify.formatMoney(
                (cart?.cost.subtotalAmount?.amount || 0) * 100,
                window.Shopify.money_format
              )}
            </span>
          </div>
        )}
      </div>

      <div className="cart-drawer__footer-item">
        <a
          href={(cart?.checkoutUrl || '').replace(
            'embark-vet.myshopify.com',
            'shop.embarkvet.com'
          )}
          disabled={!cart?.checkoutUrl}
          name={'checkout'}
          className={'btn full-width button button-primary button-full-width'}
        >
          Continue to checkout
        </a>
      </div>
    </div>
  );
};
